import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for omni lookalike targetables
 */
export interface IOmniLookalikeTargetable extends ITargetableBase {
  _cls: TargetableClass.omni_lookalike;
  audience_size: number;
}

/**
 * OmniLookalikeTargetable class for omni lookalike targetables
 */
export class OmniLookalikeTargetable extends TargetableBase<IOmniLookalikeTargetable> {
  public override className = 'Targetable.TradedeskOmniLookalikeTargetable';

  public override getDefaults(): Partial<IOmniLookalikeTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.omni_lookalike,
    };
  }

  public override get constraints(): TConstraints<IOmniLookalikeTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.omni_lookalike],
      },
    };
  }
}
